import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listWorkspaces } from '@/api/workspaces.api';
import { useWorkspaceStore } from '@/store/workspace.store';

/**
 * Carga los negocios del usuario y deja el activo elegido en el store.
 *
 * Se llama UNA vez, desde el `Layout` (el shell autenticado), antes de que las
 * pantallas empiecen a pedir datos. Importa el orden: si una pantalla pidiera
 * antes de que haya negocio activo, y el usuario tiene varios, el servidor
 * respondería 403 pidiendo que elija — que es lo correcto, pero se vería como
 * un error en vez de como una carga.
 *
 * El store persiste el activo, así que en recargas ya hay uno desde el primer
 * render y esto solo lo confirma.
 */
export function useWorkspaces(): { cargado: boolean } {
  const setWorkspaces = useWorkspaceStore((s) => s.setWorkspaces);
  const cargado = useWorkspaceStore((s) => s.cargado);

  const { data } = useQuery({
    queryKey: ['workspaces'],
    queryFn: listWorkspaces,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (!data) return;
    setWorkspaces({
      items: data.items,
      mostrarSelector: data.mostrarSelector,
      multiWorkspace: data.multiWorkspace,
    });
  }, [data, setWorkspaces]);

  return { cargado };
}
